export const applyCepMask = (value: string): string => {
    if (!value) return '';
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 5) {
        return numbers;
    }
    return `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}`;
};

export const applyProcessoMask = (value: string): string => {
    if (!value) return '';
    const numbers = value.replace(/\D/g, '');
    
    if (numbers.length <= 7) return numbers;
    if (numbers.length <= 9) return `${numbers.slice(0, 7)}-${numbers.slice(7)}`;
    if (numbers.length <= 13) return `${numbers.slice(0, 7)}-${numbers.slice(7, 9)}.${numbers.slice(9)}`;
    if (numbers.length <= 14) return `${numbers.slice(0, 7)}-${numbers.slice(7, 9)}.${numbers.slice(9, 13)}.${numbers.slice(13)}`;
    if (numbers.length <= 16) return `${numbers.slice(0, 7)}-${numbers.slice(7, 9)}.${numbers.slice(9, 13)}.${numbers.slice(13, 14)}.${numbers.slice(14)}`;
    return `${numbers.slice(0, 7)}-${numbers.slice(7, 9)}.${numbers.slice(9, 13)}.${numbers.slice(13, 14)}.${numbers.slice(14, 16)}.${numbers.slice(16, 20)}`;
};

export const applyMoneyMask = (value: string | number): string => {
    if (!value && value !== 0) return 'R$ 0,00';
    
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) return 'R$ 0,00';
    
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numValue);
};

export const removeMask = (value: string): string => {
    if (!value) return '';
    return value.replace(/\D/g, '');
};

export const formatMoneyToNumber = (value: string): number => {
    if (!value) return 0;

    const cleanValue = value.replace(/[^\d,]/g, '').replace(',', '.');
    const numValue = parseFloat(cleanValue);

    if (isNaN(numValue)) return 0;
    return numValue;
};

export const normalizeCnpj = (value: string): string => {
    if (!value) return '';
    return value.replace(/[^A-Z0-9]/gi, '').toUpperCase();
};

